<template>
  <b-form-group label class="p-0 filterPanel m-0">
    <b-form-tags v-model="selectedItemNames" no-outer-focus class="">
      <template v-slot="{ tags, disabled, addTag, removeTag }">
        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2 p-0">
          <li v-for="tag in tags" :key="tag" class="list-inline-item p-0">
            <b-form-tag
              @remove="handleRemove(tag)"
              :title="tag"
              :disabled="disabled"
              variant="info"
            >{{ tag }}</b-form-tag>
          </li>
        </ul>

        <b-dropdown variant="btnFilters" block menu-class="w-100" v-if="selectedItemIds.length === 0 || multipleAllowed">
          <template v-slot:button-content>
            {{textLabel}}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10.048"
              height="6.004"
              viewBox="0 0 10.048 6.004"
            >
              <g id="chevron-down" transform="translate(-6.996 -9.496)" opacity="0.2">
                <path
                  id="Path_137"
                  data-name="Path 137"
                  d="M12,15.5a1,1,0,0,1-.71-.29l-4-4A1,1,0,0,1,8.71,9.79L12,13.1l3.3-3.18a1,1,0,1,1,1.38,1.44l-4,3.86A1,1,0,0,1,12,15.5Z"
                  fill="#0d0500"
                />
              </g>
            </svg>
          </template>
          <b-dropdown-form @submit.stop.prevent="() => {}">
            <b-form-input
              v-model="search"
              type="search"
              size="sm"
              autocomplete="off"
              class="p-0 pl-3"
              @input="populateSuggestions"
            ></b-form-input>
          </b-dropdown-form>

          <b-dropdown-item-button
            v-for="option in availableOptions"
            :key="`source${option.id}`"
            @click="addItem(option)"
          >{{ option.name }}</b-dropdown-item-button>
          <b-dropdown-text
            v-if="availableOptions.length === 0">
            {{noData}}
          </b-dropdown-text>
        </b-dropdown>
      </template>
    </b-form-tags>
  </b-form-group>
</template>
<script>
export default {
  props: {
    textLabel: {
      type: String,
      required: true
    },
    removeItem: {
      type: Function,
      required: true
    },
    addItem: {
      type: Function,
      required: true
    },
    selectedItem: {
      type: [Object, Array],
      required: true
    },
    masterList: {
      type: Array,
      required: true
    },
    multipleAllowed: {
      type: Boolean,
      default: false
    },
    populateSuggestions: {
      type: Function,
      default: () => {}
    },
    noData: {
      type: String,
      default: "-No Options-"
    }
  },
  data(){
    return {
      search: ""
    }
  },
  methods: {
    handleRemove(tag){
      let item = this.masterList.find(abc => abc.name === tag)
      this.removeItem(item);
    }
  },
  computed: {
    availableOptions() {
      const criteria = this.criteria
      // Filter out already selected options
      const options = this.masterList.filter(opt => this.selectedItemIds.indexOf(opt.id) === -1)
      if (criteria) {
        // Show only options that match criteria
        return options.filter(opt => opt.name.toLowerCase().indexOf(criteria) > -1);
      }
      // Show all options available
      return options
    },
    criteria() {
      return this.search.trim().toLowerCase();
    },
    selectedItemNames(){
      if(Array.isArray(this.selectedItem)){
        return this.selectedItem.map(item => item.name)
      }else{
        if(this.selectedItem.name){
          return [this.selectedItem.name];
        }else{
          return [];
        }
      }
    },
    selectedItemIds(){
      if(Array.isArray(this.selectedItem)){
        return this.selectedItem.map(item => item.id)
      }else{
        if(this.selectedItem.name){
          return [this.selectedItem.id];
        }else{
          return [];
        }
      }
    },
  }
}
</script>
<style scoped>
  .filterPanel .badge-info {
    color: #ff9800;
    background-color: #ff980030;
    font-size: 13px !important;
    padding: 10px;
    border-radius: 25px;
    padding: 5px 12px;
    margin: 10px 0 5px 5px;
    font-weight: 500;
  }
</style>